import { environment } from "@/env/env.prod";

export function CaptchaWidget() {
    return (
        <div
            id="cf-turnstile"
            className="cf-turnstile"
            data-sitekey="0x4AAAAAACTtmF_89eVndl8K"//{environment.TURNSTILE_SITE_KEY}
        />
    );
}
